import React from "react";
import classnames from "classnames";
import { FormattedMessage, injectIntl } from "react-intl";

import "./style.scss";

const Checkbox = ({
  borderColor = "",
  checked = false,
  halfChecked = false,
  labelText = "",
  onChange = (checked) => checked,
}) => (
  <>
    <label className="checkbox-container" onClick={(e) => e.stopPropagation()}>
      <input
        type="checkbox"
        onChange={(e) => onChange(e.target.checked)}
        checked={checked}
      />
      <span
        className={classnames("checkmark", { halfChecked })}
        style={{ borderColor }}
      />
    </label>
    <label>
      {labelText && <FormattedMessage id={labelText} tagName="span" />}
    </label>
  </>
);

export default Checkbox;
